export const TAGS = {
	SEZNAM_VECIREK: "Seznam večírek",
	SEZNAM_FOCENI: "Seznam focení",
	LUHACOVICE: "Luhačovice",
	VALENTYN: "Valentýn",
	MANDLONE_HUSTOPECE: "Mandloně Hustopeče",
	STRANSKA_SKALA: "Stránská skála",
	KONIKLECE: "Koniklece Kamenný vrch",
	NAROZENINY_LENKA: "Narozeniny Lenka",
	NAROZENINY_ROMAN: "Narozeniny Roman",
	NAROZENINY_MARTINEK: "Narozeniny Martínek",
	NAROZENINY_TOMASEK: "Narozeniny Tomášek",
	NAROZENINY: "Narozeniny",
	SVATEK_LENKA: "Svátek Lenka",
	SVATEK_ROMAN: "Svátek Roman",
	SVATEK_MARTINEK: "Svátek Martínek",
	SVATEK_TOMASEK: "Svátek Tomášek",
	SVATEK: "Svátek",
	SAKVICE_JAHODY: "Jahody Šakvice",
	JITKA_CHALUPA: "Jitka chalupa",
	VACLAVSKY_BURCAKOVY_POCHOD: "Václavský burčákový pochod",
	BURCAKOVY_POCHOD_MUTENICE: "Burčákový pochod Mutěnice",
	POCHOD_SLOVACKYMI_VINOHRADY: "Pochod Slováckými vinohrady",
	BURCAKOVE_POCHODY: "Burčákové pochody",
	VANOCE: "Vánoce",
	KROMERIZ: "Kroměříž",
	BOJANOVICE_HODY: "Hody",
	TEHOTENSKE_FOCENI: "Těhotenské focení",
	OLOMOUC: "Olomouc",
	OLOMOUC_TRHY: "Vánoční trhy Olomouc",
	OSTRAVA_TRHY: "Vánoční trhy Ostrava",
	BRNO_TRHY: "Vánoční trhy Brno",
	TRHY: "Vánoční trhy",
	PORODNICE: "Porodnice",
	NOVOROZENECKE_FOCENI: "Novorozenecké focení",
	PRVNI_TYDEN: "První týden",
	PRVNI_MESIC: "První měsíc",
	DRUHY_MESIC: "Druhý měsíc",
	TRETI_MESIC: "Třetí měsíc",
	CTVRTY_MESIC: "Čtvrtý měsíc",
	PATY_MESIC: "Pátý měsíc",
	SESTY_MESIC: "Šestý měsíc",
	SEDMY_MESIC: "Sedmý měsíc",
	OSMY_MESIC: "Osmý měsíc",
	DEVATY_MESIC: "Devátý měsíc",
	DESATY_MESIC: "Desátý měsíc",
	JEDENACTY_MESIC: "Jedenáctý měsíc",
	DVANACTY_MESIC: "Dvanáctý měsíc",
	JEDEN_ROK: "Jeden rok",
	DETI_ROKY: "Děti roky",
	SVATBA: "Svatba",
	OTEVRENE_SKLEPY: "Otevřené sklepy",
	LEVANDULE: "Levandule",
	LOSTICE: "Loštice",
	VYROCI_SVATBY: "Výročí svatby",
	VYROCI: "Výročí",
	LEDNICE: "Lednice",
	DOVOLENA: "Dovolená",
	COKOFEST: "Čokofest",
	MESICE_MARTINEK: "Měsíce Martínek",
	MESICE_TOMASEK: "Měsíce Tomášek",
	PRIBOR: "Příbor",
	BOJANOVICE: "Bojanovice",
	HOUBY: "Houby",
	VITANI_OBCANKU: "Vítání občánků",
	PALAVA: "Pálava",
	HUSA: "Husa",
	TEHOTENSTVI: "Těhotenství",
	ZOO: "Zoo",
	SEZNAM_TMB: "Seznam teambuilding",
	SEZNAM: "Seznam",
	PLAVANI: "Plavání",
	SILVESTR: "Silvestr",
	AUTODROM: "Autodrom",
	KONCERT: "Koncert",
	ZAKLADKA_SRAZ: "Základka sraz",
	MARTINEK_DENIK: "Martínek deník",
	TOMASEK_DENIK: "Tomášek deník",
	KARNEVAL: "Karneval",
	VYSTAVA_VIN: "Výstava vín",
	OCKOVANI: "Očkování",
	FOCENI: "Focení",
	VANOCNI_FOCENI: "Vánoční focení",
	OSLAVA: "Oslava",
	ZAVODY: "Závody",
	NAROZENINOVY_VYLET: "Narozeninový výlet",
	REKONSTRUKCE: "Rekonstrukce",
	MAMKA: "Návštěva mamka",
	INBODY: "Inbody",
	VOLBY: "Volby",
	LAMPIONY: "Lampiony",
	HOSPODA: "Hospoda",
	ZNOJMO: "Znojmo",
	MIKULAS: "Mikuláš",
	SOUSEDSKE_SETKANI: "Sousedské setkání",
	PLES: "Ples",
	VINARSKY_PLES: "Vinařský ples",
	HRISTE: "Hřiště",
	VIRIVKA: "Vířivka",
	SKOLKA_MARTINEK: "Školka Martínek",
	SKOLKA_TOMASEK: "Školka Tomášek",
	SKOLKA: "Školka",
	PODCAST: "Podcast",
	NEPLECHA_UKONCENA: "Neplecha ukončena",
	SVATBA_NASE: "Svatba naše",
	VELIKONOCE: "Velikonoce",
	CARODEJNICE: "Čarodějnice",
	SRAZ: "Sraz",
	BILOVEC_SRAZ: "Bílovec sraz",
	PRIBOR_SRAZ: "Příbor sraz",
	HLIDANI: "Hlídaní",
	CROSSFIT: "Crossfit",
	TABOR: "Tábor",
	VLACEK: "Vláček",
	DIFY: "DIFY",
	DOVOLENA_SAMI: "Dovolená sami",
	VAFLE_SVARAK: "Vafle a svařák v práci",
	COVID: "Covid",
	KOST_MIKULCICE: "Košt Mikulčice",
	DOVOLENA_VELIKONCE: "Dovolená Velikonoce",
	DOVOLENA_MALA: "Dovolená malá",
	DOVOLENA_VELKA: "Dovolená velká",
	DOVOLENA_ALL_INCLUSIVE: "Dovolená all inclusive",
	DOVOLENA_MORE: "Dovolená moře",
	DOVOLENA_ZAHRANICI: "Dovolená zahraničí",
	DOVOLENA_CESKO: "Dovolená Česko",
	DOVOLENA_LENKA: "Dovolená Lenka",
	DOVOLENA_BALICEK: "Dovolená balíček",
	DOVOLENA_NAROZENINY_ROMAN: "Dovolená narozeniny Roman",
	DOVOLENA_LETECKY: "Dovolená letecky",
	DOVOLENA_AUTEM_PRES_NOC: "Dovolená autem přes noc",
	SAME_OTAZKY: "Samé otázky",
	AKCE_KAMPUS: "Akce kampus",
	MARIANSKE_UDOLI: "Mariánské údolí",
	DEN_DETI: "Den dětí",
	LANOVKA: "Lanovka",
	PRAHA: "Praha",
	DIVADLO: "Divadlo",
	KINO: "Kino",
	KOUPALISTE: "Koupaliště",
	OKURKY: "Okurky",
	MACOCHA: "Macocha",
	MORAVSKY_KRAS: "Moravský kras",
	VINOHRADY: "Vinohrady",
	SEZNAM_MASTERCHEF: "Seznam MasterChef",
	DOPIS_JEZISKOVI: "Dopis Ježíškovi",
	VAJECNAK: "Výroba vaječňáku",
	VANOCNI_STROMECEK_DOMA: "Vánoční stromeček doma",
	ROZSVICENI_STROMECKU: "Rozsvícení stromečku",
	ZDOBENI_STROMECKU_SEDMIKRASKA: "Zdobení stromečku v Sedmikrásce",
	PECENI_CUKROVI: "Pečení cukroví",
	HALLOWEEN: "Halloween",
	CHEESECAKE_RADEK: "Cheesecake s Radkem",
	NEMOC: "Nemoc",
	ZUBAR: "Zubař",
	DOKTOR: "Doktor",
	DAROVANI_KRVE: "Darování krve",
	SEDMIKRASKA: "Sedmikráska",
	STRIHANI: "Stříhání",
	BRUNCH: "Brunch",
	SPILBERK: "Špilberk",
	OLYMPIA: "Olympia",
	IKEA: "Ikea",
	HOLEDNA: "Holedná",
	HADY: "Hády",
	VELKE_PAVLOVICE: "Velké Pavlovice",
	ROZHLEDNY: "Rozhledny",
	KAMENNA_KOLONIE: "Kamenná kolonie",
	AUTO: "Auto",
	BYDLENI: "Bydlení",
	TANECNI: "Taneční",
	KVIZ: "Kvíz",
	PRIBOR_U_NAS: "Babička a děda z Příbora u nás",
	DEDA_MIREK_U_NAS: "Děda Mirek u nás",
	BABICKA_IVETA_U_NAS: "Babička Iveta u nás",
	PRABABICKA_KOPRIVNICE: "Prababička Kopřivnice",
	PRABABICKA_ZNOJMO: "Prababička Znojmo",
	PRABABICKA_MUTENICE: "Prababička Mutěnice",
	PRABABICKA_STANKA: "Prababička Staňka",
	DEDA_KAREL: "Děda Karel",
	KUBA: "Kuba",
	PETA: "Peťa",
};

/** Po pridani tagu/uprave taky upravit conf envy!!! */
export const PRIVATE_TAGS = {
	BIZAR: "Bizár",
	ZHARANI_VEREJNOST: "Zhářání na veřejnosti",
	ZTRACENE_MIMINKO: "Ztracené miminko",
};

export const ROMAN_TAGS = {
	OTEVRENE_SKLEPY: "Otevřené sklepy",
	BURCAKOVY_POCHOD_MUTENICE: "Burčákový pochod Mutěnice",
	POCHOD_SLOVACKYMI_VINOHRADY: "Pochod Slováckými vinohrady",
	BURCAKOVE_POCHODY: "Burčákové pochody",
	SEZNAM_TMB: "Seznam TMB",
	NAROZENINY: "Narozeniny",
	SVATBA: "Svatba",
	SVATBA_NASE: "Svatba naše",
	KONCERT: "Koncert",
	TATKA_CYKLODOVOLENA: "Taťka cyklodovolená",
	SEZNAM_BOBR_KEMP: "Seznam Bobr kemp",
	SEZNAM_HOSPODA: "Seznam hospoda",
	SEZNAM_VANOCNI_VECIREK: "Seznam vánoční večírek",
	SEZNAM_SVARAK: "Seznam svařák",
	SEZNAM_DESKOVKY: "Seznam deskovky",
	SEZNAM_UNIKOVKA: "Seznam únikovka",
	ZAKLADKA_SRAZ: "Základka sraz",
	ZAKLADKA: "Základka",
	PRUMYSLOVKA: "Průmyslovka",
	VYSOKA_BRNO: "FIT VUT",
	VYSOKA_OSTRAVA: "FIT Báňská",
	KOST_SLIVOVICE: "Košt slivovice",
	VYLET: "Výlet",
	BURGEROVE_SLAVNOSTI: "Burgerové slavnosti",
	TYDEN_KAVY: "Týden kávy",
	JESENIKY: "Jeseníky",
	BUDA: "Bůda",
	KOLO: "Kolo",
	KYTARA: "Kytara",
	KLAVESY: "Klávesy",
	KONZOLE: "Konzole",
	GRAFICKA_KARTA: "Grafická karta",
	NOTEBOOK: "Notebook",
	YOUTUBE: "Youtube",
	ALBUM: "Album",
	WITCHER_3: "Witcher 3",
	FLORBAL: "Florbal",
	PLES: "Ples",
	MAUTILUS: "Mautilus",
	NET_DIRECT: "Net Direct",
	SEZNAM: "Seznam",
	SILVESTR: "Silvestr",
	SEZNAM_FOCENI: "Seznam focení",
	MOR: "Masters of Rock",
};

export const LENKA_TAGS = {
	DOVOLENA: "Dovolená",
};
